module.exports = {
  setCookie: function (cname, cvalue, exdays = 3650, redirect = '') {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

    if (redirect.length) {
      setTimeout(() => {
        location.href = redirect;
      }, 1000);
    }
  },
  getCookie: function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  removeCookie: function (cname) {
    if (!this.getCookie(cname)) { return false; }
    document.cookie = encodeURIComponent(cname) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    return true;
  },
  getGclid: function () {
    var value = "; " + document.cookie;
    var parts = value.split("; gclid=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  },
  getGoogleId: function() {
    var gid = this.getCookie('_ga');
    var gidParts = gid.split('.');
    var googleId = gidParts.slice(2).join('.');
    return googleId;
  },
}
